<template>
  <div class="lion-head">
    <h1 class="lion-head-headline lion-head-headline-upper">
      Einmal L&ouml;we
    </h1>
    <audio
      id="roar"
      ref="roar">
      <source
        src="./../assets/roar.mp3"
        type="audio/mpeg"
      >
    </audio>
    <img
      class="lion-head-image"
      src="./../assets/der-loewe.svg"
      alt="Da Loewe"
      @click="handleClickOnLion"
    >
    <transition
      name="roar-animation"
    >
      <p
        v-if="roarAnimation"
        class="roar-animation-holder"
      >WWOOORRAA</p>
    </transition>
    <h1 class="lion-head-headline lion-head-headline-lower">
      Immer L&ouml;we
    </h1>
  </div>
</template>


<script>
export default {
  name: 'ElilLionHead',
  data() {
    return {
      roarAnimation: false,
    };
  },
  methods: {
    handleClickOnLion() {
      this.$refs.roar.play();
      this.roarAnimation = true;
      setTimeout(() => {
        this.roarAnimation = false;
      }, 2000);

      const counter = (this.$root.lionCounter.counter || 0) + 1;
      this.$root.$firebaseRefs.lionCounter.set({
        counter,
      });
    },
  },
};
</script>


<style lang="scss" scoped>
  .lion-head {
    width: 100%;
    text-align: center;
  }

  .lion-head-headline {
    color: white;
    font-size: 2em;
    font-weight: 900;

    @media (min-width: 320px) {
      font-size: 2.4em;
    }
    @media (min-height: 500px) and (min-width: 320px) {
      font-size: 2.8em;
    }
    @media (min-height: 600px) and (min-width: 320px) {
      font-size: 3em;
    }
    @media (min-height: 700px) and (min-width: 320px) {
      font-size: 3.5em;
    }
    @media (min-height: 1000px) and (min-width: 320px) {
      font-size: 4.5em;
    }
  }

  .lion-head-image {
    width: auto;
    max-height: 37vh;
    cursor: pointer;

    @media (min-height: 600px) and (min-width: 320px) {
      max-height: 44vh;
    }
    @media (min-height: 700px) and (min-width: 400px) {
      max-height: 49vh;
    }
    @media (min-height: 760px) and (min-width: 420px) {
      height: auto;
      max-height: none;
      width: 70%;
    }
    @media (min-height: 800px) and (min-width: 800px) {
      height: auto;
      max-height: none;
      width: 90%;
    }

  }

  .roar-animation-holder {
    position: absolute;
    color: $color-primary;
    font-weight: bold;
    text-shadow:
      0px 0px 1px rgba(255, 255, 255, 1),
      2px 2px 2px rgba(0, 0, 0, 0.8);
  }

  .roar-animation-enter-active {
    animation: roar-animation-in 2s ease-in-out;
  }
  .roar-animation-leave-active {
    animation: roar-animation-out .1s;
  }
  @keyframes roar-animation-in {
    0% {
      transform: scale(0) translate(50px, -10px) rotate(0.005turn);
    }
    100% {
      transform: scale(4) translate(50px, -120px) rotate(0.02turn);
    }
  }
  @keyframes roar-animation-out {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ElilLionHead.vue